import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import axios from "axios";
import QuestionContents from './UI/QuestionContents';
import { useParams } from "react-router-dom";
import { useAuth } from '../../../../../context/AuthContext';
import './matchcss.css';
import useSubjectName from './useSubjectName';
import useAttemptTracker, { MAX_FRONTEND_ATTEMPTS } from './useAttemptTracker';
import { API_BASE_URL } from '../../../../../Helpers/apiConfig';

const Match = (props) => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [question, setQuestion] = useState([]);
    const { user } = useAuth();
    const params = useParams();
    const subjectName = useSubjectName();
    const { getAttempt, registerWrongAttempt, clearAttempt } = useAttemptTracker(props.questionNumber);
    const [slots, setSlots] = useState([]);
    const [slotSourceIds, setSlotSourceIds] = useState([]);
    const [splitMode, setSplitMode] = useState("");

    // Satır başına düşecek maksimum buton sayısı (dar ekranlarda daha az)
    // Not: bu limit sadece "mixed" (harf) modunda kullanılıyor çünkü harfler eşit
    // genişlikte; "auto" (kelime) modunda kelimeler kısa/uzun karışık olabildiği
    // için butonlar kendi içeriğine göre genişliyor, satır sayısı doğal sarmayla belirleniyor.
    const isNarrowScreen = typeof window !== 'undefined' && window.innerWidth <= 768;
    const MAX_LETTERS_PER_ROW = isNarrowScreen ? 5 : 8;

    // Çift tıklamada aynı cevabın backend'e iki kez gönderilmesini engeller (Y7).
    const sendingRef = useRef(false);
    const Request = async (userAnswer) => {
        if (sendingRef.current) return;
        sendingRef.current = true;
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = `${API_BASE_URL}/user/Content/Answer`;

            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                clearAttempt();
                if (res.data['success']) {
                    props.playCorrectSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href =
                            "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                    });
                } else {
                    if (res.data['alertType'] === "question") {
                        props.playLastIncorrectSound?.();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: "Doğru Cevap: " + res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href =
                                "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    } else {
                        let errorMsg = res['data']['message'];
                        props.playLastIncorrectSound?.();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href =
                                "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        } catch (err) {
            sendingRef.current = false;
            setMsg(err.message);
        }
    };

    const answerMatchHandle = async (e) => {
        e.preventDefault();

        if (!props.isActiveContent) {
            Swal.fire({
                icon: "error",
                title: "Aktif Sorunuz Değil",
                text: "Bu soruyu çözebilmek için önce sırasındaki soruları tamamlamalısınız.",
                confirmButtonText: "Tamam"
            });
            return;
        }

        const isAllFilled = slots.every(slot => slot !== "");
        if (!isAllFilled) {
            Swal.fire("Uyarı", "Lütfen tüm boşlukları doldurun!", "warning");
            return;
        }

        let userAnswer = "";

        if (splitMode === "mixed") {
            let tempIndex = 0;
            const words = props.answer.split(" ");
            const userWords = words.map(w => {
                let wordStr = "";
                for (let i = 0; i < w.length; i++) {
                    wordStr += slots[tempIndex++];
                }
                return wordStr;
            });
            userAnswer = userWords.join(" ");
        } else {
            const correctAnswer = props.answer;
            const isSentence = correctAnswer.includes(" ");
            userAnswer = isSentence ? slots.join(" ").trim() : slots.join("").trim();
        }

        const correctAnswerr = props.data.answer;
        const attempt = getAttempt();

        if (attempt < MAX_FRONTEND_ATTEMPTS - 1) {
            if (userAnswer === correctAnswerr) {
                Request(userAnswer);
            } else {
                registerWrongAttempt();

                if (attempt === MAX_FRONTEND_ATTEMPTS - 2) {
                    props.playLastIncorrectSound?.();
                } else {
                    props.playFirstIncorrectSound?.();
                }
                Swal.fire({
                    title: attempt === MAX_FRONTEND_ATTEMPTS - 2 ? "Son bir kez deneyiniz!" : "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        Request(userAnswer);
    };

    const handleClick = (id) => {
        const clicked = answers.find(a => a.id === id);
        if (!clicked) return;

        const emptyIndex = slots.findIndex(x => x === "");
        if (emptyIndex === -1) return;

        props.playUnscrambleSound?.();

        setSlots(prev => {
            const copy = [...prev];
            copy[emptyIndex] = clicked.service;
            return copy;
        });

        setSlotSourceIds(prev => {
            const copy = [...prev];
            copy[emptyIndex] = id;
            return copy;
        });

        setAnswers(prev =>
            prev.map(a =>
                a.id === id ? { ...a, used: true } : a
            )
        );
    };

    const handleRemove = (index) => {
        const wordToRemove = slots[index];
        if (!wordToRemove) return;

        // Slota hangi kelime/harf butonu yerleştirildiyse (id ile) tam olarak o
        // bulunup geri açılıyor; aynı harften/kelimeden birden fazla varsa bile
        // buton kendi orijinal yerine (listedeki kendi konumuna) geri dönüyor.
        const sourceId = slotSourceIds[index];

        setSlots(prev => {
            const copy = [...prev];
            copy[index] = "";
            return copy;
        });

        setSlotSourceIds(prev => {
            const copy = [...prev];
            copy[index] = null;
            return copy;
        });

        setAnswers(prev =>
            prev.map(a =>
                a.id === sourceId ? { ...a, used: false } : a
            )
        );
    };

    useEffect(() => {
        const qContent = JSON.parse(props.data.contentStr);
        setQuestion(qContent);

        const detail = JSON.parse(props.data.detail);
        const mode = qContent['mode'] || "auto";
        setSplitMode(mode);

        if (mode === "mixed") {
            let newAnswers = [];
            let letterIdCounter = 0;
            const colors = ['#551fd4', '#e95793', '#28a745', '#ff9800', '#9c27b0', '#00bcd4'];
            const correctWords = props.answer.split(" ");

            detail.forEach((wordObj) => {
                const chars = wordObj.service.split('');
                let wordIndex = correctWords.indexOf(wordObj.service);
                if (wordIndex === -1) wordIndex = 0;

                chars.forEach(char => {
                    newAnswers.push({
                        id: `mixed_${letterIdCounter++}`,
                        service: char,
                        used: false,
                        color: colors[wordIndex % colors.length]
                    });
                });
            });

            newAnswers = newAnswers.sort(() => Math.random() - 0.5);

            setAnswers(newAnswers);
            const slotCount = props.answer.replace(/ /g, "").length;
            setSlots(new Array(slotCount).fill(""));
            setSlotSourceIds(new Array(slotCount).fill(null));
        } else {
            setSlots(new Array(detail.length).fill(""));
            setSlotSourceIds(new Array(detail.length).fill(null));
            setAnswers(detail.map(a => ({
                ...a,
                used: false
            })));
        }
    }, []);

    const getGlobalSlotIndex = (wordIndex, charIndex) => {
        const words = props.answer.split(" ");
        let previousLength = 0;
        for (let i = 0; i < wordIndex; i++) {
            previousLength += words[i].length;
        }
        return previousLength + charIndex;
    };

    // toplam buton sayısına göre satır başına düşen buton sayısı (satır limitiyle sınırlı)
    const mixedPerRow = Math.max(1, Math.min(answers.length, MAX_LETTERS_PER_ROW));

    return (
        <div className="unscramble-page">
            <span style={{ color: "black" }}>
                <b><i>{subjectName}</i></b>
            </span>
            <br />
            <br />

            <div style={{ alignItems: "center", textAlign: "center" }}>
                <QuestionContents question={question} />
                {!(question?.type === "sound" || question?.type === "video" || question?.type === "image" || question?.type === "image_sound") && (
                    <>
                        <br />
                        <br />
                    </>
                )}
                <b className="unscramble-question-text">
                    {question['text']}
                </b>
                <br /><br />
            </div>

            <div className="d-flex justify-content-center" style={{ fontSize: 20, textAlign: "center" }}>
                <form onSubmit={answerMatchHandle} className="unscramble-form">

                    <div className="container d-flex flex-column align-items-center">
                        {splitMode === "mixed" ? (
                            <div className="unscramble-mixed-words-wrap">
                                {props.answer.split(" ").map((word, wIdx) => {
                                    const colors = ['#551fd4', '#e95793', '#28a745', '#ff9800', '#9c27b0', '#00bcd4'];
                                    const wordColor = colors[wIdx % colors.length];

                                    return (
                                        <div key={wIdx} className="unscramble-word-group">
                                            {word.split('').map((char, cIdx) => {
                                                const globalIndex = getGlobalSlotIndex(wIdx, cIdx);
                                                const val = slots[globalIndex];

                                                return (
                                                    <div
                                                        key={globalIndex}
                                                        className={`slot-box ${val ? "filled clickable" : ""} unscramble-slot-box`}
                                                        onClick={() => handleRemove(globalIndex)}
                                                        style={{
                                                            border: `2px ${val ? 'solid' : 'dashed'} ${wordColor}`,
                                                            backgroundColor: val ? wordColor : '#f9f9f9',
                                                            color: val ? '#fff' : '#000',
                                                            flex: '1 1 0',
                                                            width: 'auto',
                                                            minWidth: '18px',
                                                            maxWidth: '70px',
                                                            padding: '0 2px',
                                                            boxSizing: 'border-box',
                                                        }}
                                                    >
                                                        {val || "\u00A0"}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="unscramble-auto-slots-wrap">
                                {slots.map((val, i) => (
                                    <div
                                        key={i}
                                        className={`slot-box ${val ? "filled clickable" : ""} unscramble-auto-slot`}
                                        onClick={() => handleRemove(i)}
                                        style={{
                                            border: val ? '2px solid #5768e9' : '2px dashed #ccc',
                                            backgroundColor: val ? '#551fd4' : '#f9f9f9',
                                            color: val ? '#fff' : '#000',
                                            fontSize:
                                                val && val.length > 12 ? '10px' :
                                                    val && val.length > 8 ? '12px' : '14px',
                                        }}
                                    >
                                        {val || "\u00A0"}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <br />

                    <div className="unscramble-answer-buttons">
                        {answers
                            .filter(dt => !dt.used)
                            .map((dt) => (
                                <button
                                    key={dt.id}
                                    className={`match-word-btn ${splitMode === "mixed" ? "unscramble-mixed-answer-btn" : "unscramble-auto-answer-btn"}`}
                                    type="button"
                                    onClick={() => handleClick(dt.id)}
                                    style={{
                                        ...(splitMode === "mixed" ? {
                                            backgroundColor: dt.color,
                                            borderColor: dt.color,
                                            color: '#fff',
                                            flex: `0 1 calc(${100 / mixedPerRow}% - 12px)`,
                                            maxWidth: '160px',
                                        } : {
                                            flex: '0 1 auto',
                                            minWidth: '80px',
                                            maxWidth: '260px',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                        })
                                    }}
                                >
                                    {dt.service}
                                </button>
                            ))}
                    </div>

                    <br /><br />

                    <div className="unscramble-submit-wrap">
                        {props.answered ? (
                            <b style={{ fontSize: "15px" }}>
                                <i>{props.realanswer}</i> cevaplanmış soru.
                            </b>
                        ) : (
                            <div className='d-flex justify-content-center'>
                                <button type="submit" className="save-btn">
                                    {t("saveAndContinue")}
                                </button>
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Match;